<template>
  <div class="flex flex-col gap-4 py-5">
    <h2 class="text-title-large md:text-headline-large flex grow flex-row items-center gap-0.5">
      {{ $t('settings.organization') }} <BaseIcon>chevron_right</BaseIcon>
      {{ $t('settings.general') }}
    </h2>
    <BaseCard type="filled" class="flex flex-col gap-4 p-4">
      <div>
        <div v-if="!isOrganizionNameEditable" class="flex flex-row items-center">
          <div class="flex grow flex-col pr-2">
            <h4 class="text-body-medium text-on-surface-variant">
              {{ $t('settings.organizationName') }}
            </h4>
            <span class="text-headline-small grow">{{ editableOrganization.name }}</span>
          </div>
          <BaseIconButton size="S" color="filled" icon="edit" @click="editOrganizationName" />
        </div>
        <div v-else class="flex flex-row items-center gap-1">
          <BaseInputField
            v-model="editableOrganization.name"
            :label="$t('organization.title')"
            :title="$t('organization.title')"
            type="text"
            required
            class="bg-surface-container grow"
          ></BaseInputField>
          <BaseTextButton :title="$t('common.cancel')" @click="cancelOrganizationName">{{
            $t('common.cancel')
          }}</BaseTextButton>
          <BaseTextButton
            color="filled"
            :title="$t('common.save')"
            @click="updateOrganizationName"
            >{{ $t('common.save') }}</BaseTextButton
          >
        </div>
      </div>
    </BaseCard>
  </div>
</template>
<script setup lang="ts">
  import { ref, watch } from 'vue'
  import BaseCard from '../../../core/components/base/card/BaseCard.vue'
  import BaseInputField from '../../../core/components/base/form-fields/BaseInputField.vue'
  import type { ManageableOrganization } from '../composables/useOrganization'
  import { useOrganizationSettings } from '../composables/useOrganizationSettings'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'

  interface Props {
    organization: ManageableOrganization
  }
  const props = defineProps<Props>()

  const editableOrganization = ref<ManageableOrganization>(props.organization)

  watch(
    () => props.organization,
    (newOrganization) => {
      editableOrganization.value = newOrganization
    },
    { deep: true },
  )

  const {
    isOrganizionNameEditable,
    editOrganizationName,
    updateOrganizationName,
    cancelOrganizationName,
  } = useOrganizationSettings(editableOrganization)
</script>
